<template>
  <b-container>
    <b-card class="my-3  pb-3">
      <b-card-header style="border-bottom: 2px solid #039e54">
        <div class="row">
          <div class="col-md-12">
            <h4>ทำการนัดหมาย</h4>
            <h6 class="text-secondary"> ระบบขอรับคำปรึกษาทางออนไลน์ สำหรับการขอรับคำปรึกษาผ่านทางวีดีโอคอล
              โดยไม่ต้องเข้ามาติดต่อขอรับบริการที่ ศูนย์บริการผลิตภัณฑ์สุขภาพเบ็ดเสร็จ (OSSC)
              สำนักงานสาธารณสุขจังหวัดนนทบุรี</h6>
          </div>
        </div>
      </b-card-header>
      <b-card-text>
        <!-- <div class="row" v-if="checkclosetime()">
          <div class="col m-5 text-center text-danger"><h4>ท่านสามารถเข้าระบบเพื่อจองคิวได้ในเวลาทำการ 8.30-16.30 น.</h4></div>
        </div>
        <div class="row" v-else> -->
        <div class="row">
          <div class="col">
            <b-form @submit="preSave">
              <b-form-group>
                <div class="card mt-3 h-100">
                  <div class="card-body">
                    <h5 class="card-title text-success">ประเภทการจอง</h5>
                    <div class="row mt-2">
                      <div class="col">
                        <b-form-checkbox v-model="booking_for_others" name="booking_for_others" :value="true" :unchecked-value="false">
                          จองให้ผู้อื่น
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card mt-3 h-100">
                  <div class="card-body">
                    <h5 class="card-title text-success">การแจ้งเตือนล่วงหน้า</h5>
                    <div class="row mt-2">
                      <div class="col">
                        <b-form-group v-slot="{ ariaDescribedby }">
                          <b-form-radio v-model="selected_alert" :aria-describedby="ariaDescribedby" name="some-radios"
                            value="email">รับแจ้งเตือนล่วงหน้าผ่านทาง E-mail</b-form-radio>
                          <b-form-radio v-model="selected_alert" :aria-describedby="ariaDescribedby" name="some-radios"
                            value="line">รับแจ้งเตือนล่วงหน้าผ่านทาง Line Official Account {{ $LINE_OA }}</b-form-radio>
                          <b-form-radio v-model="selected_alert" :aria-describedby="ariaDescribedby" name="some-radios"
                            :disabled="is_have_user_line == 'n'" value="all">รับแจ้งเตือนล่วงหน้าผ่านทาง Line Official
                            Account และ E-mail</b-form-radio>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="mx-3" v-if="selected_alert != 'email'">
                      <div class="row">
                        <div class="col-lg-4">
                          <div>
                            <!-- ปุ่มเชื่อมต่อกับ LINE -->
                            <div @click="openLineLoginPopup" class="p-2" v-if="is_have_user_line == 'n'"
                              style="display: flex; align-items: center; justify-content: center; background-color: #00C300; color: white; border: none; border-radius: 5px; cursor: pointer; width: 170px; margin-bottom: 15px; font-size: 16px;">
                              <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/LINE_logo.svg"
                                alt="LINE Logo" style="width: 20px; height: 20px; margin-right: 8px;">
                              เชื่อมต่อกับ LINE
                            </div>
                            <div class="mb-3" v-else>
                              <p class="text-success d-inline">เชื่อมต่อกับ LINE เรียบร้อยแล้ว</p>
                            </div>
                          </div>
                          <div>
                            <!-- ปุ่มเพิ่มเพื่อน LINE OA -->
                            <a :href="LINE_URL_ADD_FRIEND" target="_blank" style="text-decoration: none;">
                              <div class="p-2"
                                style="display: flex; align-items: center; justify-content: center; background-color: #32C5FF; color: white; border: none; border-radius: 5px; cursor: pointer; width: 180px; font-size: 16px;">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/LINE_logo.svg"
                                  alt="LINE Logo" style="width: 20px; height: 20px; margin-right: 8px;">
                                เพิ่มเพื่อน LINE OA
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="mt-3"> <small class="text-danger">การรับแจ้งเตือนผ่านไลน์ท่านจำเป็นต้องเชื่อมต่อกับ
                            Line และ
                            เพิ่มเพื่อน Line Official Account {{ $LINE_OA }} </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card mt-3 h-100 pb-3">
                  <div class="card-body">
                    <h5 class="card-title text-success">ข้อมูลผู้ติดต่อ</h5>
                    <div class="row mt-2">
                      <div class="col-lg-4 col-12 mt-2">
                        <label>ชื่อสถานประกอบการ</label>
                        <div>
                          <b-form-input v-model="form.company_name" placeholder="โปรดระบุ" required> </b-form-input>
                        </div>
                      </div>
                      <div class="col-lg-4 col-12 mt-2">
                        <label>อำเภอ</label>
                        <div>
                          <b-form-select v-model="form.amphur" clearabled required>
                            <option :value="null" disabled hidden>โปรดระบุ</option>
                            <option v-for="opt in optAmphur" :value="opt.value" :key="opt.value">
                              {{ opt.text }}
                            </option>
                          </b-form-select>
                        </div>
                      </div>
                      <div class="col-lg-4 col-12 mt-2">
                        <label>ประเภทผลิตภัณฑ์ (เลือกพรบ.)</label>
                        <b-form-select v-model="form.license" required>
                          <option :value="null" disabled hidden>โปรดระบุ</option>
                          <option v-for="opt in optionsProductType" :value="opt.value" :key="opt.value">
                            {{ opt.text }}
                          </option>
                        </b-form-select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4 col-12 mt-2">
                        <label>เลขบัตรประจำตัวประชาชน</label>
                        <div>
                          <b-form-input v-model="form.contract_cid" placeholder="โปรดระบุ" required maxlength="13"
                            @keypress="isNumber($event)" autocomplete="off" @keyup="validateCitizenID"></b-form-input>
                          <small class="text-danger">{{ check_cid_status }}</small>
                        </div>
                      </div>
                      <div class="col-lg-4 col-12 mt-2">
                        <label>ชื่อผู้ติดต่อ</label>
                        <div>
                          <b-form-input v-model="form.nameContact" placeholder="โปรดระบุ" required
                            :value="user.name"></b-form-input>
                        </div>
                      </div>
                      <div class="col-lg-4 col-12 mt-2">
                        <label>เบอร์โทร</label>
                        <div>
                          <input type="text" class="form-control" v-model="form.telCompany" @input="acceptNumber"
                            required placeholder="โปรดระบุ">
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-4 col-12 mt-2">
                        <label>E-mail</label>
                        <div>
                          <b-form-input v-model="form.email" placeholder="โปรดระบุ" required></b-form-input>
                        </div>
                      </div>
                      <div class="col-lg-4 col-12 mt-2">
                        <label>Line ID</label>
                        <div>
                          <b-form-input v-model="form.line_id" placeholder="ไม่บังคับ"></b-form-input>
                        </div>
                      </div>
                      <div class="col-lg-4 col-12 mt-2">
                        <label>เลขที่ใบอนุญาต</label>
                        <div>
                          <b-form-input v-model="form.license_no" placeholder="ไม่บังคับ"></b-form-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card mt-3 h-100 pb-3">
                  <div class="card-body">
                    <h5 class="card-title text-success">เรื่องที่จะติดต่อ</h5>
                    <div class="row mt-2">
                      <div class="col-lg-4 col-12 mt-2" v-if="requestType">
                        <label>ประเภท</label>
                        <b-form-select v-model="requestTypeSub" required> <!--  @change="getQueueStatus"  -->
                          <option :value="null" disabled hidden>โปรดระบุ</option>
                          <option v-for="opt in optionsRequestTypeSub" :value="opt.value" :key="opt.value">
                            {{ opt.text }}
                          </option>
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                </div>

                <b-card class="mt-3" title="วัตถุประสงค์การนัดหมาย">
                  <b-form-group label="วัตถุประสงค์" label-for="appointment-purpose">
                    <b-form-select id="appointment-purpose" v-model="purposeId" required @change="purposeDetail = ''">
                      <option :value="null" disabled>โปรดเลือกวัตถุประสงค์</option>
                      <option v-for="purpose in purposes" :key="purpose.purpose_id" :value="purpose.purpose_id">{{ purpose.purpose_text }}</option>
                    </b-form-select>
                  </b-form-group>
                  <b-alert :show="!!purposeError" variant="danger">{{ purposeError }} <b-button size="sm" @click="getPurposes">ลองอีกครั้ง</b-button></b-alert>
                  <b-form-group v-if="selectedPurpose && selectedPurpose.requires_detail" label="โปรดระบุวัตถุประสงค์อื่นๆ" label-for="purpose-detail">
                    <b-form-textarea id="purpose-detail" v-model="purposeDetail" required maxlength="1000" />
                  </b-form-group>
                  <appointment-documents :purpose="selectedPurpose" />
                  <b-form-group v-if="selectedPurpose" label="แนบเอกสารประกอบการนัดหมาย" label-for="booking-attachments"
                    description="PDF, JPG หรือ PNG ไฟล์ละไม่เกิน 10 MB ครั้งละไม่เกิน 10 ไฟล์ สามารถรวมเอกสารไว้ใน PDF เดียวได้">
                    <b-form-file id="booking-attachments" v-model="bookingFiles" multiple accept=".pdf,.jpg,.jpeg,.png"
                      :required="requiresAttachments" :disabled="saving" browse-text="เลือกไฟล์" placeholder="เลือกเอกสารหรือรูปภาพ" />
                  </b-form-group>
                  <p v-if="attachmentError" class="text-danger" role="alert">{{ attachmentError }}</p>
                  <p v-if="requiresAttachments && !bookingFiles.length" class="text-danger">โปรดแนบเอกสารประกอบก่อนเลือกวันนัดหมาย</p>
                </b-card>
                <div class="row mt-2   pb-3" v-if="requestTypeSub && canChooseDate">
                  <div class="col">
                    <div class="card mt-3 h-100">
                      <div class="card-body">
                        <h5 class="card-title text-success">เลือกวันที่ต้องการจอง</h5>
                        <div class="row">
                          <div class="col-12 col-lg-6 my-2">
                            <label>เลือกวัน :</label>
                            <div class="text-center">
                              <v-date-picker is-expanded :min-date="minBookingDate"
                                @dayclick="gettime" locale="th-TH" color="orange" value="" :weekday-format="getDay"
                                :disabled-dates='list_datoff' />
                            </div>
                          </div>
                          <div class="col-12 col-lg-6 my-2" v-if="date_selected">
                            <label>เลือกช่วงเวลา :</label>
                            <div class="text-center">
                              <p class="m-2" v-if="date_selected" style="font-size: 20px; font-weight: bold">
                                {{ getdateformat(date_selected) }}
                              </p>
                            </div>
                            <div class="m-3" v-if="!timelist">วันนี้ไม่มีการให้บริการ</div>
                            <div v-else class="text-center">
                              <div class="row">
                                <div class="col text-center">
                                  <div v-for="(val, index) in timelist.slice(0, 8)" :key="index">
                                    <b-button variant="outline-dark" class="m-1 py-1" size="sm"
                                      :disabled="val.queue_time != null"
                                      @click="selecttime(index, timelist.slice(0, 8))">{{
                                        val.time_text }}
                                    </b-button>
                                  </div>
                                </div>
                                <!-- <div v-if="timelist.length > 8" class="col-6 text-left">
                                  <div v-for="(val, index) in timelist.slice(8, timelist.length)" :key="index">
                                    <b-button variant="outline-dark" class="m-1 py-1" size="sm"
                                      :disabled="val.queue_time != null"
                                      @click="selecttime(index, timelist.slice(8, timelist.length))">{{
                                        val.time_text }}
                                    </b-button>
                                  </div>
                                </div> -->
                              </div>
                            </div>
                            <div class="text-center mt-1">
                              <div v-if="date_afterselect && time_afterselect">
                                <div class="m-2" style="font-size: 20px">
                                  <p class="m-0 p-0 text-primary">ยืนยันเลือก</p>
                                  {{ date_afterselect }}
                                  <br />{{ time_afterselect }}
                                </div>
                              </div>
                              <div v-else>

                                ยังไม่ได้เลือกเวลา
                                <p style="font-size: 13px" class="mx-2 mt-2 text-danger">
                                  * ข้อมูลจำเป็นต้องระบุ
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col text-right m-3">
                    <b-button variant="success" type="submit" :disabled="!can_save || !canChooseDate || saving">{{ saving ? 'กำลังบันทึก...' : 'จองคิว' }}</b-button>
                  </div>
                </div>
              </b-form-group>
            </b-form>
          </div>
        </div>

      </b-card-text>
    </b-card>
  </b-container>

</template>
<script>

import axios from "axios";
import AppointmentDocuments from "../components/AppointmentDocuments.vue";
import moment from "moment";
import { getdateformat } from "../functions.js";
import { displayToast } from "../functions.js";
import { Script_checkID } from "../functions.js";
import { modalOKDisplay } from "../functions.js";
import { mapState } from 'vuex'

import { config } from '../../config.js';


export default {
  components: { AppointmentDocuments },
  data() {
    return {
      purposes: [],
      purposeId: null,
      purposeDetail: "",
      purposeError: "",
      bookingFiles: [],
      saving: false,
      selected: [],
      selected_alert: null,
      booking_for_others: false,

      LINE_CLIENT_ID: config.LINE_CLIENT_ID,
      LINE_REDIRECT_URI: config.LINE_REDIRECT_URI,
      LINE_URL_ADD_FRIEND: config.LINE_URL_ADD_FRIEND,
      is_have_user_line: null,
      satisfaction_other: null,
      lastid: null,
      minday: 0,
      first_booking_date: '',
      encode_id: null,
      form: {
        company_name: '',
        amphur: null,
        contract_cid: '',
        license: null,
        nameContact: '',
        telCompany: '',
        license_no: null,
        email: '',
        line_id: ''
      },
      locale: 'th-TH',
      labels: {
        'th-TH': {
          labelHelp: 'เลื่อนลูกศรเพื่อเลือกเดือน/ปี',
          labelNoDateSelected: 'ระบุวันที่ได้รับ',
        }
      },


      timelist: [],
      date_selected: '',
      time_selected: '',
      date_afterselect: '',
      time_afterselect: '',
      check_cid_status: "",
      request_group: null,
      can_save: false,
      loading: false,
      optionsProductType: [],
      list_satisfaction: [],
      listCompany: [],
      optAmphur: [],
      //dateNow: new Date(),
      accesstoken: '',
      textsearch: '',
      companySelected: null,
      optionsRequestType: [],
      list_datoff: [],
      optionsRequestTypeSub: [],
      requestType: 1,
      requestTypeSub: null
    };
  },
  computed: {
    minBookingDate() {
      if (!this.first_booking_date) return null;
      const parts = this.first_booking_date.split('-').map(Number);
      return new Date(parts[0], parts[1] - 1, parts[2]);
    },
    requiresAttachments() { return !!(this.selectedPurpose && this.selectedPurpose.documents.length); },
    attachmentError() {
      if (this.bookingFiles.length > 10) return 'แนบไฟล์ได้ไม่เกิน 10 ไฟล์';
      if (this.bookingFiles.some(f => !/\.(pdf|jpe?g|png)$/i.test(f.name) || !f.size || f.size > 10 * 1024 * 1024)) {
        return 'โปรดเลือก PDF, JPG หรือ PNG ที่มีขนาดไม่เกิน 10 MB และไม่ใช่ไฟล์ว่าง';
      }
      return '';
    },
    canChooseDate() {
      return !!this.selectedPurpose && !this.attachmentError && (!this.requiresAttachments || this.bookingFiles.length > 0)
        && (!this.selectedPurpose.requires_detail || !!this.purposeDetail.trim());
    },
    selectedPurpose() { return this.purposes.find(p => p.purpose_id === this.purposeId); },
    checkAllSatisfaction() {
      return this.selected.length == this.list_satisfaction.length ? false : true
    },
    getDay(date) {
      const WeekDays = ['7', '1', '2', '3', '4', '5', '6'];
      return WeekDays[date.weekday];
    },
    ...mapState({
      user: store => store.user
    })
  },
  watch: {
    purposeId() { this.bookingFiles = []; this.resetAppointmentDate(); },
    bookingFiles() { this.resetAppointmentDate(); },
    canChooseDate(value) { if (!value) this.resetAppointmentDate(); }
  },
  created() {
    if (localStorage.getItem("ssj_token") !== null) {
      this.$store.dispatch('setUser').then(response => {
        this.form.contract_cid = this.user.citizen_id
        this.form.nameContact = this.user.name
        this.form.telCompany = this.user.phone_number
        this.form.email = this.user.email
        this.can_save = true
        this.acceptNumber()
        this.getusername()

      }
      )
      this.accesstoken = localStorage.getItem("ssj_token");
      this.getPurposes()
      this.getLicense()
      this.getRequestTypeSub()
      this.getAmphur()
      this.getDateOFF()

    } else {
      this.$router.push("/auth");
    }
  },
  // mounted(){
  //   this.$refs["mdlSatisfaction"].show();
  // },
  methods: {
    resetAppointmentDate() {
      this.date_selected = ''; this.time_selected = ''; this.date_afterselect = ''; this.time_afterselect = ''; this.timelist = [];
    },
    async getPurposes() {
      this.purposeError = '';
      try {
        const { data } = await axios.post('/api/request.php', { function: 'get_appointment_purposes' });
        if (!data.status || !Array.isArray(data.data)) throw new Error();
        this.purposes = data.data;
      } catch (e) { this.purposeError = 'โหลดวัตถุประสงค์ไม่สำเร็จ โปรดลองอีกครั้ง'; }
    },
    getdateformat,
    displayToast,
    Script_checkID,
    modalOKDisplay,
    openLineLoginPopup() {
      // สร้าง URL สำหรับ LINE Login
      const stateData = {
        csrfToken: this.generateState(),
        citizen_id: this.user.citizen_id
      };

      const params = new URLSearchParams({
        response_type: 'code',
        client_id: this.LINE_CLIENT_ID,
        redirect_uri: this.LINE_REDIRECT_URI,
        state: btoa(JSON.stringify(stateData)), // เข้ารหัส Base64
        scope: 'profile openid email'
      });

      const lineLoginUrl = `https://access.line.me/oauth2/v2.1/authorize?${params.toString()}`;

      // เปิด LINE Login ใน popup
      const popup = window.open(
        lineLoginUrl,
        '_blank',
        'width=500,height=600,scrollbars=yes'
      );

      // ตรวจสอบเมื่อ popup ถูกปิด
      const interval = setInterval(() => {
        if (popup.closed) {
          clearInterval(interval); // หยุดตรวจสอบเมื่อ popup ถูกปิด
          console.log('Popup closed! Refreshing parent window...');
          this.getusername()
        }
      }, 500); // ตรวจสอบทุกๆ 500 มิลลิวินาที
    },
    generateState() {
      // สร้างค่า state แบบสุ่ม
      return Math.random().toString(36).substring(2);
    },

    checkclosetime() {
      var now = moment();
      var hourToCheck = 16;
      var dateToCheck = now.hour(hourToCheck).minute(30);

      return moment().isAfter(dateToCheck);
    },
    hidemodal() {
      this.$refs["mdlSatisfaction"].hide();
      this.$router.push("/queue_detail/" + this.encode_id);
    },
    getusername() {
      axios
        .post("/api/getuser.php", {
          accesstoken: this.accesstoken
        })
        .then((result) => {
          this.is_have_user_line = result.data.is_have_user_line
        });
    },

    preSave(event) {
      event.preventDefault();
      if (!this.canChooseDate || this.saving) {
        this.modalOKDisplay(this.attachmentError || 'โปรดระบุวัตถุประสงค์และแนบเอกสารประกอบก่อนเลือกวันนัดหมาย', 'แจ้งเตือน');
        return;
      }
      if (!this.selectedPurpose || (this.selectedPurpose.requires_detail && !this.purposeDetail.trim())) {
        this.modalOKDisplay('โปรดระบุวัตถุประสงค์การนัดหมายให้ครบถ้วน', 'แจ้งเตือน');
        return;
      }
      if (this.date_selected == '' || this.time_selected == '') {
        this.modalOKDisplay('โปรดระบุวันและเวลาที่ต้องการจอง', 'แจ้งเตือน')
      } else {
        // console.log(this.file)
        const h = this.$createElement;
        const messageVNode = h("div", {
          domProps: {
            innerHTML:
              "ข้าพเจ้าขอรับรองว่า ข้อมูลต่างๆ ตามที่ข้าพเจ้าระบุไว้ดังกล่าวข้างต้น<br> เป็นข้อมูลที่ถูกต้องครบถ้วนตรงตามความเป็นจริงทุกประการ",
          },
        });
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: "กรุณายืนยันข้อมูล",
            size: "md",
            buttonSize: "md",
            okVariant: "success",
            okTitle: "จองคิว",
            cancelTitle: "ยกเลิก",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              this.SaveQueue()
            }
          });
      }
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateCitizenID() {
      // this.can_take_queue = false
      this.form.nameContact = ''
      this.form.telCompany = ''
      let cid = this.form.contract_cid
      if (cid.length == 13) {
        let id = cid.replace(/-/g, "");
        let result = this.Script_checkID(id);
        if (result) {
          this.can_save = true
          this.check_cid_status = ""
          // this.can_take_queue = true
          // this.getQueueStatus()
        } else {
          this.check_cid_status = "รูปแบบบัตรไม่ถูกต้อง"
        }
      } else {
        this.can_save = false
        this.check_cid_status = ""
      }
    },
    acceptNumber() {
      var x = this.form.telCompany.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.form.telCompany = !x[2] ? x[1] : '' + x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    selecttime(index, list) {
      this.date_afterselect =
        " วันที่ " +
        this.getdateformat(this.date_selected);
      this.time_afterselect = " เวลา " + list[index].time_text + " น.";
      this.time_selected = list[index].time_slot_id
    },
    getDateOFF() {
      axios
        .post("api/dateoff.php", {
          accesstoken: this.accesstoken,
          function: "get_dateoff_only"
        })
        .then((response) => {
          if (response.data.status) {
            this.list_datoff = response.data.data;
            this.minday = response.data.minday;
            this.first_booking_date = response.data.first_booking_date;
            this.list_datoff.push({ weekdays: [1, 7] })
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getQueueStatus() {
      axios
        .post("api/queue.php", {
          accesstoken: this.accesstoken,
          cid: this.form.contract_cid,
          requestType: this.requestType,
          requestTypeSub: this.requestTypeSub,
          function: "get_queue_status"
        })
        .then((response) => {
          if (response.data.status) {
            this.queue_status_list = response.data.data
            this.can_save = true
            // this.can_take_queue = true
          } else {
            this.can_save = false
            // this.can_take_queue = false
            this.modalOKDisplay(response.data.msg, 'แจ้งเตือน')
            this.requestTypeSub = null
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getLicense() {
      axios
        .post("api/license.php", {
          accesstoken: this.accesstoken,
          function: "get_license"
        })
        .then((response) => {
          if (response.data.status) {
            this.optionsProductType = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRequestType() {
      axios
        .post("api/request.php", {
          accesstoken: this.accesstoken,
          function: "get_request_type"
        })
        .then((response) => {
          if (response.data.status) {
            this.optionsRequestType = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRequestTypeSub() {

      this.clearCalendar()
      this.optionsRequestTypeSub = []
      this.requestTypeSub = null
      axios
        .post("api/request.php", {
          accesstoken: this.accesstoken,
          function: "get_request_type_sub",
          request_type: this.requestType
        })
        .then((response) => {
          if (response.data.status) {
            this.optionsRequestTypeSub = response.data.data;
            this.request_group = response.data.data[0].request_group
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAmphur() {
      axios
        .post("api/amphur.php", {
          accesstoken: this.accesstoken,
          function: "get_amphur"
        })
        .then((response) => {
          if (response.data.status) {
            this.optAmphur = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    gettime(day) {
      if (!this.canChooseDate || this.saving) return;
      this.timelist = []
      if (day.isDisabled == false) {
        // let arr_holiday = [1, 7]
        // if (arr_holiday.indexOf(day.weekday) == -1) {
        this.date_afterselect = day.id
        this.date_selected = day.id;
        axios
          .post("api/gettime.php", {
            date: day.id,
            request_group: this.request_group
          })
          .then((data) => {
            this.timelist = data.data.data;
          });
      } else {
        this.date_afterselect = ''
        this.date_selected = "วันปิดทำการ"
      }
    },
    SaveQueue() {
      if (!this.canChooseDate || this.saving || !this.date_selected || !this.time_selected) return;
      this.saving = true;
      const form = new FormData();
      form.append('payload', JSON.stringify({
          function: 'save_queue',
          purpose_id: this.purposeId,
          purpose_detail: this.purposeDetail,
          accesstoken: this.accesstoken,
          date_selected: this.date_selected,
          time_selected: this.time_selected,
          requestType: this.requestType,
          requestTypeSub: this.requestTypeSub,
          request_group: this.request_group,
          license_no: this.license_no,
          formdata: this.form,

          selected_alert: this.selected_alert,
          booking_for_others: this.booking_for_others

         }));
      this.bookingFiles.forEach(file => form.append('attachments[]', file));
      axios.post('api/queue.php', form)
        .then((response) => {
          if (response.data.status) {
            this.encode_id = response.data.encode_id
            this.lastid = response.data.last_id
            this.$router.push("/queue_detail/" + this.encode_id);
          } else {
            this.modalOKDisplay(response.data.msg || 'พบข้อผิดพลาด โปรดลองอีกครั้ง', 'แจ้งเตือน')
          }
        })
        .catch((error) => {
          this.modalOKDisplay((error.response && error.response.data.msg) || 'บันทึกไม่สำเร็จ โปรดตรวจสอบขนาดไฟล์และลองอีกครั้ง', 'แจ้งเตือน');
        }).finally(() => { this.saving = false; });

    },
    clearCalendar() {
      this.timelist = []
      this.date_selected = null
      this.date_afterselect = null
    }
  }
};
</script>


<style>
.table-hover tbody tr:hover td,
.table-hover tbody tr:hover th {
  background-color: #c5c9c7;
  color: #000000;
  cursor: pointer;
}

.card-body-main {
  background-color: beige;
  border-radius: 15px;
}

.column_wrapper {
  column-count: 2;
}
</style>
